import React, { useEffect, useRef, useCallback } from 'react';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input } from '~/components/Form';
import { t } from '~/helpers';

import * as S from './styles';

export default function Forms({ sending, onForm }) {
  const formRef = useRef(null);

  const handleSubmit = useCallback(async (data) => {
    try {
      const schema = Yup.object().shape({
        justificativa: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(10, t('s.geral.validacao.tamanhominimo').replace('%s', 10))
          .max(255, t('s.geral.validacao.tamanhomaximo').replace('%s', 255)),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      onForm(data);
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        formRef.current.setErrors(validationErrors);
      }
    }
  }, []);

  useEffect(() => {
    if (sending) formRef.current.submitForm();
  }, [sending]);

  return (
    <S.Wrapper ref={formRef} onSubmit={handleSubmit}>
      <Input multiline name="justificativa" label="Justificativa" rows={4} />
    </S.Wrapper>
  );
}

Forms.propTypes = {
  sending: PropTypes.bool.isRequired,
  onForm: PropTypes.func.isRequired,
};
